export const authConfig = {
    clientId: '9tyZdj7CIAXD50G4Vh3jqCsJmniwAuiA',
    domain: 'thejacksonlaboratory.auth0.com',
    audience: 'https://cube.jax.org',
};